export default "__VITE_ASSET__CF7$1D0s__"